import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import Style from "./ChartAdmDis.module.scss";

type Props = {
	dailyCensusTitle: string;
	dailyCensusValue: string;
	dailyCensusColor: string;
	labelEnabled?: boolean;
	label?: string;
	isHospitalDemo?: boolean;
	/** Per-area breakdown, rendered inside the section so it sits above the separator. */
	breakdown?: ReactNode;
};
export const ChartAdmDis = ({ dailyCensusTitle, dailyCensusValue, dailyCensusColor, labelEnabled, label, isHospitalDemo, breakdown }: Props) => {
	const { t } = useTranslation();
	return (
		<div className={isHospitalDemo ? `${Style.census} ${Style.demo}` : Style.census}>
			<div className={Style.dailyCensusTitle}>{dailyCensusTitle ? dailyCensusTitle : ""}</div>
			<div
				className={labelEnabled ? Style.dailyCensusValueOverview : Style.dailyCensusValue}
				// Value renders in the difficulty threshold color (demo separator/font come from the .demo class).
				style={{ color: dailyCensusColor }}
			>
				{dailyCensusValue}
			</div>
			{labelEnabled && <p className={Style.label}>{label}</p>}
			{breakdown}
		</div>
	);
};
